import { Fragment } from 'react'
import { Grid, IconButton } from '@material-ui/core'
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit'
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModalFullscreen } from '../redux/features/modalSlice'

export const DialogTitle = (props) => {
  const modal = useSelector((state) => state.modal)
  const dispatch = useDispatch()

  return (
    <Fragment>
      <Grid item xs={12} className="d-flex flex-row justify-content-between align-items-start">
        <div>{props.title}</div>
        {modal.showFullscreenOption &&
          (modal.isFullscreen ? (
            <IconButton size="small" onClick={() => dispatch(toggleModalFullscreen(false))}>
              <FullscreenExitIcon />
            </IconButton>
          ) : (
            <IconButton size="small" onClick={() => dispatch(toggleModalFullscreen(true))}>
              <FullscreenIcon />
            </IconButton>
          ))}
      </Grid>
    </Fragment>
  )
}
